module.exports = __webpack_public_path__ + "img/西安交通大学logo.a91340bf.png";